<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" :titulo="titulo" style="flex: 1 0 100%" />
    <div slot="menu" class="menucontextual">
      <SeccionOcultable titulo="Documentación" v-if="hasDocumentacion">
        <ul>
          <li
            v-for="itemDocumento in siniestro.documentosSiniestro"
            :key="'d' + itemDocumento.id"
          >
            <a
              href="#"
              target="_blank"
              class="ripple"
              @click.prevent="downloadDocumento(itemDocumento.uuid)"
            >
              {{ itemDocumento.nombreDoc }}
              <br />
              <label class="fechaFirma">
                {{ labelDocumento(itemDocumento) }}
                {{ itemDocumento.fechaFirma | dateDDMMYYYY }}
              </label>
            </a>
          </li>
        </ul>
      </SeccionOcultable>
    </div>

    <div v-if="siniestro" slot="contenido" class="tarjetario">
      <!-- 
              Observese que hay 2 v-for debajo de este contenedor y ambos
              tienen un id como clave. Si un id de encargo es igual a un id de contrario 
              se produce una colision, por eso se genera la key con 'c'+id  y 'e'+id
            -->
      <DatosGenerales :siniestro="siniestro" />

      <Contrario
        v-for="itemContrario in siniestro.contrarios"
        :key="'c' + itemContrario.id"
        :contrario="itemContrario"
      />

      <Encargo
        v-for="itemEncargo in siniestro.encargos"
        :key="'e' + itemEncargo.id"
        :encargo="itemEncargo"
      />

      <Historial :siniestro="siniestro" style="flex: 0 1 100%" />
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    siniestro() {
      return this.$store.state.seleccion;
    },
    titulo() {
      return "Siniestro: " + this.siniestro.nsg("numSiniestro");
    },
    hasDocumentacion() {
      return this.siniestro.nsg("documentosSiniestro.length");
    },
  },

  methods: {
    downloadDocumento: async function (uuid) {
      this.$store.dispatch("dowloadDocumento", uuid);
    },
    labelDocumento(doc) {
      let etiq;
      if (doc.aceptado) etiq = "Firmado el ";
      else etiq = "Rechazado el ";
      return etiq;
    },
  },

  beforeRouteEnter: async function (to, from, next) {
    await fetchData(to.params.numSiniestro);
    next();
  },

  beforeRouteUpdate: async function (to, from, next) {
    await fetchData(to.params.numSiniestro);
    next();
  },
};

import store from "@/store/store.js";
async function fetchData(numSiniestro) {
  await store.dispatch("getSiniestroVeh", numSiniestro);
}
</script>

<style lang="scss" scoped>
.fechaFirma {
  font-size: 85%;
  color: darkgrey;
}
</style>
